import type {ReactElement} from 'react';
import React from 'react';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {RGBA} from '@Utils/color.util';
import {getRGBAArrayFromColorStorage} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import type {ColorStorage} from '@Components/color-picker-v2';

interface BaseMultiplyColorPanelProps {
  multiplyColor: RGBA;
  onUpdateMultiplyColor(multiplyColor: RGBA, undoable?: boolean): void;
}

export function BaseMultiplyColorPanel({...props}: BaseMultiplyColorPanelProps): ReactElement<any> {
  const onChangeMultiplyColor = (updatedColor: ColorStorage[]): void => {
    props.onUpdateMultiplyColor(getRGBAArrayFromColorStorage(updatedColor)[0], false);
  };

  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    props.onUpdateMultiplyColor(getRGBAArrayFromColorStorage(updatedColor)[0]);
  };

  return (
    <PosterEditingBaseColorPanel
      id="item-multiply-color-panel"
      color={getColorObjectArrayFromFillColor([props.multiplyColor])}
      isGradientEnabled={false}
      onChangeColor={onChangeMultiplyColor}
      onChangeEnded={onChangeColorEnded}
    />
  );
}
